import React from "react";
import jalaliMoment from "jalali-moment";
import { DateObject } from "react-multi-date-picker";

const formatDateAndTimeOnline = (inputDate) => {
  const jalaliDateAndTime = new DateObject(inputDate);

  if (jalaliDateAndTime.year < 1600) {
    const dateString = `${jalaliDateAndTime.year}-${
      jalaliDateAndTime.monthIndex + 1
    }-${jalaliDateAndTime.day}`;

    // Convert to Gregorian date
    const gregorianDate = jalaliMoment(dateString, "jYYYY-jMM-jDD")
      .locale("en")
      .format("YYYY-MM-DD");

    // Format the time string
    const timeString = `${jalaliDateAndTime.hour
      .toString()
      .padStart(2, "0")}:${jalaliDateAndTime.minute
      .toString()
      .padStart(2, "0")}:${jalaliDateAndTime.second
      .toString()
      .padStart(2, "0")}`;

    // Combine date and time
    const gregorianDateAndTime = `${gregorianDate}%20${timeString}`;

    return gregorianDateAndTime;
  } else if (
    jalaliDateAndTime.year === 2024 &&
    jalaliDateAndTime.monthIndex === 0 &&
    jalaliDateAndTime.day === 21
  ) {
    // Handle special case for specific date
    const gregorianDate = `${jalaliDateAndTime.year}-${
      jalaliDateAndTime.monthIndex + 1
    }-${jalaliDateAndTime.day}`;
    const timeString = `${jalaliDateAndTime.hour
      .toString()
      .padStart(2, "0")}:${jalaliDateAndTime.minute
      .toString()
      .padStart(2, "0")}:${jalaliDateAndTime.second
      .toString()
      .padStart(2, "0")}`;
    const gregorianDateAndTime = `${gregorianDate}%20${timeString}`;

    return gregorianDateAndTime;
  } else {
    // Handle other dates
    const gregorianDate = `${jalaliDateAndTime.year}-${
      jalaliDateAndTime.monthIndex + 1
    }-${jalaliDateAndTime.day}`;
    const timeString = `${jalaliDateAndTime.hour
      .toString()
      .padStart(2, "0")}:${jalaliDateAndTime.minute
      .toString()
      .padStart(2, "0")}:${jalaliDateAndTime.second
      .toString()
      .padStart(2, "0")}`;
    const gregorianDateAndTime = `${gregorianDate}%20${timeString}`;

    return gregorianDateAndTime;
  }
};

const formatDateAndTimeHourly = (inputDate) => {
  const formattedInput = formatDateAndTimeOnline(inputDate);
  // Ensure inputDate is a string
  const dateString = String(formattedInput);

  // Replace "%20" with space and slice to keep only the date and time part
  const newDateString = dateString.replace("%20", " ").slice(0, 19);

  // Convert the formatted date string to a Date object
  const convertedToDateObjectInputDate = new Date(newDateString);

  // Subtract one hour
  convertedToDateObjectInputDate.setHours(
    convertedToDateObjectInputDate.getHours() - 1
  );

  // Get the parts of the date for formatting
  const year = convertedToDateObjectInputDate.getFullYear();
  const month = ("0" + (convertedToDateObjectInputDate.getMonth() + 1)).slice(
    -2
  );
  const day = ("0" + convertedToDateObjectInputDate.getDate()).slice(-2);
  const hours = ("0" + convertedToDateObjectInputDate.getHours()).slice(-2);

  // Format the date string
  const formattedDateString = `${year}-${month}-${day}%20${hours}:00:00`;

  return formattedDateString;
};

const formatDateDaily = (date) => {
  const dateObject = new Date(date);
  const year = dateObject.getFullYear();
  const month = dateObject.getMonth() + 1; // Months are zero-based, so add 1
  const day = dateObject.getDate().toString().padStart(2, "0");
  const gregorianTime = new Date(`${year}-${month}-${day}`);
  gregorianTime.setDate(gregorianTime.getDate() - 1); // Because of backend format deduct 1

  const formattedDay = gregorianTime.getDate().toString().padStart(2, "0");
  const gregorianMonth = gregorianTime.getMonth() + 1; // Adding 1 because getMonth() returns a zero-based index
  const formattedMonth = gregorianMonth.toString().padStart(2, "0"); // Convert to string and pad with leading
  const formattedTime = `${gregorianTime.getFullYear()}-${formattedMonth}-${formattedDay}%2010:00:00`;
  return formattedTime;
};

const formatDateAndTimeHourlySound = (inputDate) => {
  const formattedInput = formatDateAndTimeOnline(inputDate);
  // Ensure inputDate is a string
  const dateString = String(formattedInput);

  // Replace "%20" with space and slice to keep only the date and time part
  const newDateString = dateString.replace("%20", " ").slice(0, 19);

  // Convert the formatted date string to a Date object
  const convertedToDateObjectInputDate = new Date(newDateString);

  // Get the parts of the date for formatting
  const year = convertedToDateObjectInputDate.getFullYear();
  const month = ("0" + (convertedToDateObjectInputDate.getMonth() + 1)).slice(
    -2
  );
  const day = ("0" + convertedToDateObjectInputDate.getDate()).slice(-2);
  const hours = ("0" + convertedToDateObjectInputDate.getHours()).slice(-2);

  // Format the date string
  const formattedDateString = `${year}-${month}-${day}%20${hours}:00:00`;

  return formattedDateString;
};

const formatDateAndTimeHourlyAQMS = (inputDate) => {
  const formattedInput = formatDateAndTimeOnline(inputDate);
  // Ensure inputDate is a string
  const dateString = String(formattedInput);

  // Replace "%20" with space and slice to keep only the date and time part
  const newDateString = dateString.replace("%20", " ").slice(0, 19);

  // Convert the formatted date string to a Date object
  const convertedToDateObjectInputDate = new Date(newDateString);

  // Get the parts of the date for formatting
  const year = convertedToDateObjectInputDate.getFullYear();
  const month = ("0" + (convertedToDateObjectInputDate.getMonth() + 1)).slice(
    -2
  );
  const day = ("0" + convertedToDateObjectInputDate.getDate()).slice(-2);
  const hours = ("0" + convertedToDateObjectInputDate.getHours()).slice(-2);

  // Format the date string
  const formattedDateString = `${year}-${month}-${day}%20${hours}:00:00`;

  return formattedDateString;
};

export {
  formatDateAndTimeOnline,
  formatDateAndTimeHourly,
  formatDateDaily,
  formatDateAndTimeHourlySound,
  formatDateAndTimeHourlyAQMS,
};
